// extracted by mini-css-extract-plugin
module.exports = {"container":"Home_container__3-qjB","wrapper":"Home_wrapper__2ah44","title":"Home_title__1ks5w","chart":"Home_chart__bV9Xi"};